<template>
    <div v-if="walletDetails" class="historyDet-wrap">
        <div class="historyDet-items">
            <div class="historyDet-item" v-if="walletDetails?.status == 0">
                <span class="historyDet-key">{{$t('requested-amount', 'Requested Amount')}}</span>
                <span class="historyDet-value">{{ walletDetails?.stake }}</span>
            </div>
            <template v-else>
                <div class="historyDet-item">
                    <span class="historyDet-key">{{$t('requested-amount', 'Requested Amount')}}</span>
                    <span class="historyDet-value">{{ walletDetails?.approved_rejected_amount }}</span>
                </div>
                <div class="historyDet-item">
                    <span class="historyDet-key">{{walletDetails?.status == 1 ? $t('accepted-amount', 'Accepted Amount') : (walletDetails?.status == 2 ? $t('rejected-amount', 'Rejected Amount') : $t('processing-amount', 'Processing Amount'))}}</span>
                    <span class="historyDet-value">{{ walletDetails?.approved_rejected_amount }}</span>
                </div>
            </template>
            <div class="historyDet-item">
                <span class="historyDet-key">{{$t('request-date', 'Request Date')}}</span>
                <span class="historyDet-value">{{ $dateTime.getLocalDate(walletDetails?.created_at, 'DD MMM YYYY HH:mm A') }}</span>
            </div>
            <div class="historyDet-item">
                <span class="historyDet-key">{{$t('action-on', 'Action on')}}</span>
                <span class="historyDet-value">{{ $dateTime.getLocalDate(walletDetails?.updated_at, 'DD MMM YYYY HH:mm A') }}</span>
            </div>
            <div class="historyDet-item">
                <span class="historyDet-key">{{$t('reference-no', 'Reference No.')}}</span>
                <span class="historyDet-value">{{ walletDetails?.transaction_id }}</span>
            </div>
            <div class="historyDet-item">
                <span class="historyDet-key">{{$t('remarks', 'Remarks')}}</span>
                <span class="historyDet-value">{{ walletDetails?.agent_remarks !== 'null' ? walletDetails?.agent_remarks : '-' }}</span>
            </div>
        </div>
        <div  v-if="$siteSettings?.data?.social_link.whatsappno1" class="whatsapp-btnWrap">
            <a :href="'//wa.me/'+$siteSettings?.data?.social_link.whatsappno1" target="_blank" class="whatsapp-btn">
                <span class="whatsapp-icon">
                    <img src="@/assets/images/whatsapp-social.svg" alt="" loading="lazy">
                </span>
                {{$t('whatsapp-now', 'Whatsapp')}}
            </a>
        </div>
    </div>
</template>
<script>
export default {
    name: "TransactionDetail",
    props: ['walletDetails']
}
</script>